import * as API from '@/services';
import { prepareContentWithBase64Images } from '@/utils';
import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import {
	formatWorkerUseTipDetail,
	formatWorkerUseTipList,
} from './worker-use-tip.helper';
import { WorkerUseTipActions } from './worker-use-tip.redux';
import {
	IPayloadGetWorkerUseTipDetailRequest,
	IPayloadGetWorkerUseTipListRequest,
} from './worker-use-tip.type';

export function* getWorkerUseTipList(
	action: PayloadAction<IPayloadGetWorkerUseTipListRequest>
) {
	const { callback, searchTypes, ...rest } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.GetWorkerUseTipListResponse> =
			yield API.getWorkerUseTipList({ searchTypes, ...rest });
		const content = formatWorkerUseTipList(res?.data?.content);

		yield put(
			WorkerUseTipActions.getWorkerUseTipListSuccess({
				...rest,
				content,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(WorkerUseTipActions.getWorkerUseTipListFailure());
	}
}

export function* getWorkerUseTipDetail(
	action: PayloadAction<IPayloadGetWorkerUseTipDetailRequest>
) {
	const { id, callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.IWorkerUseTip> =
			yield API.getWorkerUseTipDetail(id);

		const detail = formatWorkerUseTipDetail(res.data);

		const content: string = yield prepareContentWithBase64Images(
			detail.content
		);

		yield put(
			WorkerUseTipActions.getWorkerUseTipDetailSuccess({
				detail: {
					...detail,
					content,
				},
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(WorkerUseTipActions.getWorkerUseTipDetailFailure());
	}
}
